module.exports = __webpack_public_path__ + "img/1_hills.ec9b7137.jpg";